import { ContentDirection } from '@design-system/types';
import { useCallback, useEffect, useMemo, useState } from 'react';

function useDomDirection(): ContentDirection {
  const isBrowser = typeof window !== 'undefined';

  const [domDirection, setDomDirection] = useState(
    (isBrowser && (document.documentElement.dir as ContentDirection)) ||
      ContentDirection.LTR
  );

  const dirChangeHandler = useCallback((mutationList: MutationRecord[]) => {
    setDomDirection(
      (mutationList[0].target as HTMLElement).dir as ContentDirection
    );
  }, []);

  const dirChangeObserver = useMemo(
    () => (isBrowser ? new MutationObserver(dirChangeHandler) : null),
    [dirChangeHandler]
  );

  useEffect(() => {
    if (isBrowser) {
      setDomDirection(document.documentElement.dir as ContentDirection);

      dirChangeObserver?.observe(document.documentElement, {
        attributeFilter: ['dir'],
      });
    }

    return () => {
      dirChangeObserver?.disconnect();
    };
  }, [dirChangeObserver]);

  return domDirection;
}

export default useDomDirection;
